module.exports = __webpack_public_path__ + "assets/img/notBeginBtn.766280aa.png";